<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="单据日期">
              <a-range-picker @change="dateChange"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="客户"
            >
              <a-input-search
                placeholder="请选择客户"
                @change="customerTextChange"
                @search="onCustomerSearch"
                v-model="customerName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >
      <div slot="lastMoney" slot-scope="text, record">
        <span style="padding-right: 5px;">{{ lastMoney(record.money, record.paidMoney) }}</span>
      </div>
      <span slot="action" slot-scope="text, record">
        <a @click="addItem(record)">收款</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="itemDetail(record)">记录</a>
            </a-menu-item>
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此收款单据吗?删除后相关收款记录将同时删除！" @confirm="deleteConfirm(record)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <CustomerModal :visible="customerModalvisible" @handleCancel="customerModalCancel" @handleOk="customerModalOk"></CustomerModal>
    <ProceedsAddItem
      :visible="proceedsItemAddShow"
      @handleCancel="proceedsItemAddCancel"
      @handleOk="proceedsItemAddOk"
      :title="title"
      :mpiId="mpRow.id"
      :customerId="mpRow.customerId"
      :lastMoney="lastMoney(mpRow.money, mpRow.paidMoney)"
    ></ProceedsAddItem>
    <getProceedsItemsList
      :visible="itemsDetailvisible"
      @handleCancel="itemsModoalCancel"
      @handleOk="itemsModoalCancel"
      :mpiId="mpRow.id"
      :title="title"
    >
    </getProceedsItemsList>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import CustomerModal from '@/components/Customer/Modal'
import ProceedsAddItem from '@/components/Money/Proceeds/AddItem'
import getProceedsItemsList from '@/components/Money/Proceeds/Items'
import { getProceedsList, deleteProceeds } from '@/api/money'
import ACol from 'ant-design-vue/es/grid/Col'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'MoneyProceedsList',
  components: {
    ACol,
    STable,
    CustomerModal,
    ProceedsAddItem,
    getProceedsItemsList
  },
  data () {
    return {
      proceedsItemAddShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      isEditForm: false,
      title: '新建收款对账单',
      selectrow: {},
      mpRow: {},

      // 查询参数
      queryParam: {
        s_date: null,
        e_date: null,
        customerId: ''
      },
      customerName: '',
      categoryData: null,
      customerModalvisible: false,
      itemsDetailvisible: false,
      // 表头
      columns: [
        {
          title: '单据编号',
          dataIndex: 'locationNo',
          className: 'text-center'
        },
        {
          title: '对账日期',
          dataIndex: 'date',
          className: 'text-center'
        },
        {
          title: '客户',
          dataIndex: 'customer.name',
          className: 'text-center'
        },
        {
          title: '应收金额(元)',
          dataIndex: 'money',
          className: 'text-right'
        },
        {
          title: '已收金额(元)',
          dataIndex: 'paidMoney',
          className: 'text-right'
        },
        {
          title: '剩余金额(元)',
          className: 'text-right',
          scopedSlots: { customRender: 'lastMoney' }
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center'
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getProceedsList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
  },
  methods: {
    lastMoney (money, money2) {
      const money3 = money - money2
      return money3.toFixed(2)
    },
    customerTextChange (e) {
      if (!e.data) {
        this.queryParam.customerId = '0'
      }
    },
    customerModalCancel () {
      this.customerModalvisible = false
    },
    customerModalOk (selectedRows) {
      this.customerModalvisible = false
      if (selectedRows.length > 0) {
        const rowData = selectedRows.pop()
        this.queryParam.customerId = rowData.id
        this.customerName = rowData.name
      }
    },
    onCustomerSearch () {
      this.customerModalvisible = true
    },
    dateChange (date, dateString) {
      this.queryParam.s_date = dateString[0]
      this.queryParam.e_date = dateString[1]
    },
    handleAdd () {
      this.$router.push({ path: '/money/proceeds/add' })
    },

    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    proceedsItemAddOk () {
      this.proceedsItemAddShow = false
      this.$refs.table.refresh()
    },
    proceedsItemAddCancel () {
      this.proceedsItemAddShow = false
      this.$refs.table.refresh()
    },
    addItem (record) {
      this.mpRow = record
      this.title = '收款/单据：' + record.locationNo
      this.proceedsItemAddShow = true
    },
    itemDetail (record) {
      this.mpRow = record
      this.title = '收款明细记录/单据：' + record.locationNo
      this.itemsDetailvisible = true
    },
    itemsModoalCancel () {
      this.itemsDetailvisible = false
    },
    deleteConfirm (record) {
      deleteProceeds({ id: record.id }).then(res => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.reload()
      })
    }
  },
  watch: {
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
